module.exports = __webpack_public_path__ + "static/img/login-bg.6ca65e52.png";